import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PurchaseRequisitionInfoWidgetComponent } from './purchase-requisition-info-widget.component';
import { TranslateModule } from '@ngx-translate/core';
import { IimCardModule } from '@iim-angular/components';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [PurchaseRequisitionInfoWidgetComponent],
    imports: [CommonModule, TranslateModule, IimCardModule, RouterModule],
    exports: [PurchaseRequisitionInfoWidgetComponent],
})
export class PurchaseRequisitionInfoWidgetModule {}
